import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import { useEffect, useState } from 'react';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { addQueuePromoCount } from '../../../store/emarsys/action';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { PAGE_NAME_PROMO } from '../../../constants/emarsys/promo';

interface Props {
  pageName: string;
  pageTitle: string;
  breadcrumbItems: IBreadcrumbs[];
  newParams?: Record<string, string | number | boolean>;
}

const useViewPromo = ({ pageName, pageTitle, breadcrumbItems, newParams }: Props) => {
  const dispatch = useDispatch();
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    const isFlagActive = getFlagValue('EMARSYS');
    const isFlagPromoListActive = getFlagValue(FLAG_ENUM.EMARSYS_PROMO_LIST);
    const isFlagPromoActive = getFlagValue(FLAG_ENUM.EMARSYS_PROMO);
    if (
      isAuth &&
      isFlagActive &&
      ((pageName === PAGE_NAME_PROMO.PROMO_LISTING_PAGE && isFlagPromoListActive) ||
        (pageName !== PAGE_NAME_PROMO.PROMO_LISTING_PAGE && isFlagPromoActive)) &&
      firstLoad
    ) {
      setFirstLoad(false);
      if (userData?.customerNo) {
        ScarabQueue.push(['setCustomerId', userData?.customerNo]);
      }

      const valuePageView: Record<string, string | number | boolean> = {
        page_name: pageName ?? '',
        page_title: pageTitle ?? '',
        page_url: window.location.href,
        menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toLowerCase() || '',
        ...newParams,
      };

      ScarabQueue.push(['tag', 'page_view', valuePageView]);

      dispatch(addQueuePromoCount());
    }
  }, [isAuth]);
};

export default useViewPromo;
